import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useTRPC } from 'utils/trpc'
import { useAiHelp } from './AiHelpProvider'
import { useAiHelpContext } from './useAiHelpContext'

export function useAiHelpSend() {
    const trpc = useTRPC()
    const { messages, conversationId, addUserMessage, addAssistantMessage, setIsLoading, isLoading, clearHighlights, isInStepFlow, exitStepFlow } = useAiHelp()
    const getContext = useAiHelpContext()

    const sendMutation = useMutation(
        trpc.aiHelp.sendMessage.mutationOptions({
            onSuccess: data => {
                addAssistantMessage({
                    role: 'assistant',
                    content: data.content,
                    highlights: data.highlights,
                    steps: data.steps,
                    ticketLogged: data.ticketLogged,
                })
                setIsLoading(false)
            },
            onError: () => {
                addAssistantMessage({
                    role: 'assistant',
                    content: 'Sorry, I encountered an error. Please try again.',
                })
                setIsLoading(false)
            },
        }),
    )

    const send = useCallback(
        (text: string) => {
            const trimmed = text.trim()
            if (!trimmed || isLoading) return

            // Exit step flow if a new question is asked during it
            if (isInStepFlow) {
                exitStepFlow()
            }

            clearHighlights()
            addUserMessage(trimmed)
            setIsLoading(true)

            sendMutation.mutate({
                messages: messages.map(m => ({ role: m.role, content: m.content })),
                message: trimmed,
                context: getContext(),
                conversationId,
            })
        },
        [messages, conversationId, isLoading, getContext, isInStepFlow],
    )

    return send
}
